'use client';
import * as React from 'react';

/**
 * No-op shim for react-helmet-async in Next.js.
 * Next.js uses generateMetadata / metadata exports instead.
 */
export const Helmet: React.FC<{ children?: React.ReactNode }> = () => null;
export const HelmetProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => <>{children}</>;
export default Helmet;
